<template>
    <div :key="rerenderRulePanelKey">
        <div style="width: 100%; margin: 10px;">
            <v-btn icon @click.native="left()">
                <v-icon color="grey lighten-1">mdi-arrow-left</v-icon>
            </v-btn>
            <b>{{copyValue.name}}/Rules</b>
            <v-btn style="float: right; margin-right: 12px;" icon @click.native="closePanel()">
                <v-icon color="grey lighten-1">mdi-close</v-icon>
            </v-btn>
        </div>
        <v-divider/>
        <v-card v-for="(rule, idx) in copyValue.aggregateRules" :key="idx" style="margin-bottom: 15px;">
            <div :key="updateRulePanel">
                <v-card-title>
                    <div style="width: 100%;">
                        <v-btn style="float: right; margin: -15px;" icon @click.native="deleteAggregateRule(idx)">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                        <v-text-field
                            v-model="rule.ruleName"
                            :rules="[ruleRequired]"
                            label="Rule Name"
                        ></v-text-field>
                    </div>
                </v-card-title>
                <div style="margin: 15px;">
                    <v-autocomplete
                        v-model="rule.givenValue"
                        :items="givenItems"
                        @click.native="chooseGivenEvent(idx)"
                        item-text="name"
                        dense
                        return-object
                        label="Given"
                    ></v-autocomplete>
                    <v-autocomplete
                        v-model="rule.whenValue"
                        :items="rule.whenItems"
                        @click.native="chooseWhenPolicy(idx)"
                        item-text="name"
                        dense
                        return-object
                        label="When"
                    ></v-autocomplete>
                    <v-autocomplete
                        v-model="rule.thenValue"
                        :items="rule.thenItems"
                        item-text="name"
                        @click.native="chooseThenEvent(idx)"
                        dense
                        return-object
                        label="Then"
                    ></v-autocomplete>
                </div>
            </div>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    v-if="rule.givenValue || rule.thenValue"
                    color="primary"
                    text
                    small
                    @click.native="openExampleDialog(rule)"
                >
                    Examples
                </v-btn>
            </v-card-actions>
        </v-card>


        <div style="width: 100%; margin-bottom: 15px;">
            <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn icon @click.native="addAggregateRule()" v-bind="attrs" v-on="on">
                        <v-icon color="grey lighten-1">mdi-plus</v-icon>
                    </v-btn>
                </template>
                <span>Add New Rule</span>
            </v-tooltip>
        </div>

        <v-dialog v-model="isOpenRules" persistent width="100%">
            <v-card>
                <v-toolbar color="grey lighten-4">
                    <v-toolbar-title>
                        <span v-if="openRules.ruleName"><b>{{ openRules.ruleName }}/Examples</b></span>
                        <span v-else><b>.../Examples</b></span>
                    </v-toolbar-title>

                    <v-spacer></v-spacer>

                    <v-btn style="float: right;" icon @click.native="resetAttribute(openRules, 'save')">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>

                <span style="width: 100%; display: flex; height: 40px; background-color: #f8f8f8;">
                    <!-- text-align: center; -->
                    <b style="width: 49%; margin: 10px;">Given</b>
                    <v-divider vertical />
                    <b style="width: 50%; margin: 10px;">Then</b>
                </span>

                <v-divider></v-divider>
                <span style="width: 100%; display: flex; height: 600px; overflow-y:scroll;">
                    <ag-grid-vue
                        style="width: 50%;"
                        class="ag-theme-alpine"
                        :columnDefs="givenColumnDefs"
                        :rowData="givenRowData"
                        :defaultColDef="defaultColDef"
                        rowSelection="single"
                        @row-selected="onRowSelected"
                        @grid-ready="ongivenGridReady"
                        :enableRangeSelection="false"
                        :enableFillHandle="false"
                        :undoRedoCellEditing="true"
                        :undoRedoCellEditingLimit="30"
                        :enableCellChangeFlash="true"
                        domLayout="autoHeight"
                    >
                    </ag-grid-vue>
                    <ag-grid-vue
                        style="width: 50%;"
                        class="ag-theme-alpine"
                        :columnDefs="thenColumnDefs"
                        :rowData="thenRowData"
                        :defaultColDef="defaultColDef"
                        rowSelection="single"
                        @row-selected="onRowSelected"
                        @grid-ready="onthenGridReady"
                        :enableRangeSelection="false"
                        :enableFillHandle="false"
                        :undoRedoCellEditing="true"
                        :undoRedoCellEditingLimit="30"
                        :enableCellChangeFlash="true"
                        domLayout="autoHeight"
                    >
                    </ag-grid-vue>
                </span>
                <v-divider></v-divider>
                <div style="background-color: white; width: 100%;">
                    <v-tooltip right>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn v-if="openRules.givenValue" icon @click.native="addAggregateRuleAttribute(openRules)" v-bind="attrs" v-on="on">
                                <v-icon>mdi-plus</v-icon>
                            </v-btn>
                        </template>
                        <span>Add New Example</span>
                    </v-tooltip>
                    <v-btn v-if="rowIndex!=null" icon @click.native="deleteAggregateRuleAttribute(openRules)">
                        <v-icon>mdi-delete</v-icon>
                    </v-btn>
                    <v-btn text color="primary" style="float: right; margin-right: 10px;" @click.native="resetAttribute(openRules, 'save')">
                        Save
                    </v-btn>
                </div>
            </v-card>
        </v-dialog>

    </div>
</template>

<script>
    import { AgGridVue } from "ag-grid-vue";

    export default {
        name: 'aggregate-rules-panel',
        props: {
            copyValue: {
                type: Object,
                default: function () {
                    return null
                }
            },
            givenItems: {
                type: Array,
                default: function () {
                    return []
                }
            },
            attachedPolicies:{
                type: Object,
                default: function () {
                    return null
                }
            }
        },
        components:{
            AgGridVue
        },
        data() {
            return {
                rerenderRulePanelKey: 0,
                updateRulePanel: 0,
                canvasbase: null,
                ruleRequired: value => !!value || 'Required.',
                thenColumnDefs: [],
                thenRowData: [],
                defaultColDef: {
                    editable: true,
                    resizable: true,
                },
                givenGridApi: null,
                thenGridApi: null,
                rowIndex: null,
                givenColumnDefs: [],
                givenRowData: [],
                ruleValues: {
                    ruleName: null,
                    whenItems: [],
                    thenItems: [],
                    givenValue: null,
                    whenValue: null,
                    thenValue: null,
                    show: false,
                    editMode: false,
                    attributes: []
                },
                ruleAttribute: {
                    givenAtt: {
                        attKey: [],
                        attValue: [],
                    },
                    aggregateAtt: {
                        attKey: [],
                        attValue: [],
                    },
                    thenAtt: {
                        attKey: [],
                        attValue: [],
                    },
                },
                openRules:{},
                isOpenRules: false,
            }
        },
        created() {
            var me = this
            me.canvasbase = me.getComponent('event-storming-model-canvas')
            if (!me.copyValue.aggregateRules) {
                me.addAggregateRule()
            } else {
                for (var i = 0; i < me.copyValue.aggregateRules.length; i++) {
                    me.copyValue.aggregateRules[i].show = false
                    me.copyValue.aggregateRules[i].editMode = false
                }
            }
        },
        methods: {
            left(){
                this.$emit('left')
            },
            closePanel() {
                this.$emit('close')
            },
            openExampleDialog(rule){
                var me = this

                try{
                    me.rowIndex = null

                    me.givenColumnDefs = [
                        { headerName: rule.givenValue.name, children: []},
                        { headerName: me.copyValue.name, children: []},
                    ]
                    me.thenColumnDefs = [
                        { headerName: rule.thenValue.name, children: []},
                    ]
                    me.givenRowData = null
                    me.thenRowData = null

                    var givenItem = []
                    var thenItem = []

                    me.givenName = null
                    me.aggregateName = null
                    me.thenName = null

                    for(var i = 0; i < rule.givenValue.fieldDescriptors.length; i++){
                        var childrenValue = {
                            // headerName: rule.givenValue.name + "." + rule.givenValue.fieldDescriptors[i].name,
                            headerName: rule.givenValue.fieldDescriptors[i].name,
                            field: rule.givenValue.name + rule.givenValue.fieldDescriptors[i].name,
                        }
                        me.givenColumnDefs[0].children.push(childrenValue)

                        me.givenName = rule.givenValue.name

                        Object.keys(rule.attributes).forEach(function (idx){
                            if(!givenItem[idx]){
                                givenItem[idx] = []
                            }
                            if(rule.attributes[idx].givenAtt[i] && rule.attributes[idx].givenAtt[i].attValue){
                                givenItem[idx][me.givenName + rule.givenValue.fieldDescriptors[i].name] = rule.attributes[idx].givenAtt[i].attValue
                            } else {
                                givenItem[idx][me.givenName + rule.givenValue.fieldDescriptors[i].name] = null
                            }
                        })
                    }
                    for(var i = 0; i < me.copyValue.aggregateRoot.fieldDescriptors.length; i++){
                        var childrenValue = {
                            // headerName: me.copyValue.name + "." + me.copyValue.aggregateRoot.fieldDescriptors[i].name,
                            headerName: me.copyValue.aggregateRoot.fieldDescriptors[i].name,
                            field: me.copyValue.name + me.copyValue.aggregateRoot.fieldDescriptors[i].name,
                        }
                        me.givenColumnDefs[1].children.push(childrenValue)

                        me.aggregateName = me.copyValue.name

                        Object.keys(rule.attributes).forEach(function (idx){
                            if(rule.attributes[idx].aggregateAtt[i] && rule.attributes[idx].aggregateAtt[i].attValue){
                                givenItem[idx][me.aggregateName + me.copyValue.aggregateRoot.fieldDescriptors[i].name] = rule.attributes[idx].aggregateAtt[i].attValue
                            } else {
                                givenItem[idx][me.aggregateName + me.copyValue.aggregateRoot.fieldDescriptors[i].name] = null
                            }
                        })
                    }
                    if(rule.thenValue!=null){
                        for(var i = 0; i < rule.thenValue.fieldDescriptors.length; i++){
                            var childrenValue = {
                                // headerName: rule.thenValue.name + "." + rule.thenValue.fieldDescriptors[i].name,
                                headerName: rule.thenValue.fieldDescriptors[i].name,
                                field: rule.thenValue.name + rule.thenValue.fieldDescriptors[i].name,
                            }
                            me.thenColumnDefs[0].children.push(childrenValue)

                            me.thenName = rule.thenValue.name

                            Object.keys(rule.attributes).forEach(function (idx){
                                if(!thenItem[idx]){
                                    thenItem[idx] = []
                                }
                                if(rule.attributes[idx].thenAtt[i] && rule.attributes[idx].thenAtt[i].attValue){
                                    thenItem[idx][me.thenName + rule.thenValue.fieldDescriptors[i].name] = rule.attributes[idx].thenAtt[i].attValue
                                } else {
                                    thenItem[idx][me.thenName + rule.thenValue.fieldDescriptors[i].name] = null
                                }
                            })
                        }
                    }
                    me.givenRowData = givenItem
                    me.thenRowData = thenItem

                    // console.log(me.givenName, me.aggregateName, me.thenName)
                    // console.log(me.givenRowData, me.thenRowData)
                    me.openRules = rule
                }catch (e) {
                    console.log('[Error] OpenExampleDialog : ', e)
                }finally {
                    me.isOpenRules = true
                }
            },
            
            ongivenGridReady(params) {
                this.givenGridApi = params.api;
            },
            onthenGridReady(params) {
                this.thenGridApi = params.api;
            },
            onRowSelected(event) {
                if (event.node.selected == true) {
                    this.rowIndex = event.node.rowIndex
                }
            },
            chooseGivenEvent(index){
                var me = this
                var incomingEvent = [] // 붙어 있는 폴리스들과 연결 되어 있는 외부 event 
                // rule.whenValue = null
                // rule.thenValue = null
                // rule.attributes = []

                // me.copyValue.aggregateRules[index].whenValue = null
                // me.copyValue.aggregateRules[index].thenValue = null
                // me.copyValue.aggregateRules[index].attributes = []

                // var attribute = JSON.parse(JSON.stringify(me.copyValue.aggregateRules[index].attributes))
                // me.copyValue.aggregateRules[index].attributes.push(attribute)
                
                // console.log(me.copyValue.aggregateRules[index].whenValue)
                if(Object.values(me.canvasbase.value.relations).length>0){
                    Object.values(me.canvasbase.value.relations).forEach(function(rel, idx){
                        if(rel != null){
                            if(rel.sourceElement._type == 'org.uengine.modeling.model.Event' && rel.targetElement._type == 'org.uengine.modeling.model.Policy'){
                                if(me.copyValue.aggregateRules[index].whenValue && me.copyValue.aggregateRules[index].whenValue.elementView){
                                    if(me.copyValue.aggregateRules[index].whenValue.elementView.id == rel.targetElement.elementView.id){
                                        incomingEvent.push(rel.sourceElement);
                                    }
                                }
                                else{
                                    if(me.attachedPolicies[rel.targetElement.elementView.id]){
                                        incomingEvent.push(rel.sourceElement);
                                    }
                                }
                            }
                        }
                    })
                }
                
                me.givenItems = incomingEvent

                this.copyValue.aggregateRules[index].givenItems = incomingEvent
                // console.log("given value "+ index)
                // console.log(this.copyValue.aggregateRules[index].givenItems) 
                
                // console.log(incomingEvent)
                if(incomingEvent.length == 1 && !this.copyValue.aggregateRules[index].givenValue){
                    this.copyValue.aggregateRules[index].givenValue = incomingEvent[0]
                }
                
            },

            addAggregateRuleAttribute(rule) {
                var me = this
                me.resetAttribute(rule, 'add');
            },
            deleteAggregateRuleAttribute(rule) {
                var me = this
                me.resetAttribute(rule, 'delete');
            },
            addAggregateRule() {
                var me = this                

                var values = JSON.parse(JSON.stringify(me.ruleValues))
                var attribute = JSON.parse(JSON.stringify(me.ruleAttribute))
                if(!me.copyValue.aggregateRules){
                    var idx = 0
                    me.copyValue.aggregateRules = []
                } else {
                    var idx = me.copyValue.aggregateRules.length
                }

                // me.aggregateRules.push(values)
                me.copyValue.aggregateRules.push(values)
                me.copyValue.aggregateRules[idx].attributes.push(attribute)
                me.chooseGivenEvent(idx)
                me.chooseWhenPolicy(idx)
                me.chooseThenEvent(idx)
                if(idx == 0){
                    if(me.copyValue.aggregateRules[idx].givenValue && me.copyValue.aggregateRules[idx].thenValue){
                        me.copyValue.aggregateRules[idx].ruleName = `Whenever Rental is ${me.copyValue.aggregateRules[idx].givenValue.name}, ${me.copyValue.aggregateRules[idx].thenValue.name}`
                    }
                    me.rerenderRulePanelKey++;
                } else {
                    me.updateRulePanel++;
                }
            },
            deleteAggregateRule(idx) {
                var me = this
                me.copyValue.aggregateRules.splice(idx, 1)
                me.updateRulePanel++;
            },
            chooseWhenPolicy(index){
                var chosenPolicy = []
                var me = this
                
                if(me.copyValue.aggregateRules[index].givenValue == 'undefined' || me.copyValue.aggregateRules[index].givenValue == null ){

                    Object.values(me.attachedPolicies).forEach(function(policy, idx){
                        chosenPolicy.push(policy)
                    })
                    // console.log("policies1")
                    this.copyValue.aggregateRules[index].whenItems = chosenPolicy
                    // console.log(this.copyValue.aggregateRules[index].whenItems)
                }
                else{
                    if(Object.values(me.canvasbase.value.relations).length > 0){
                        Object.values(me.canvasbase.value.relations).forEach(function(rel, idx){
                            if(rel != null && me.copyValue.aggregateRules[index].givenValue && me.copyValue.aggregateRules[index].givenValue.elementView){
                                if(rel.sourceElement._type == 'org.uengine.modeling.model.Event' && rel.targetElement._type == 'org.uengine.modeling.model.Policy'){
                                    if(me.copyValue.aggregateRules[index].givenValue.elementView.id == rel.sourceElement.elementView.id){
                                        chosenPolicy.push(rel.targetElement)
                                    }
                                }
                            }
                        })
                    }
                    // this.aggregateRules[index].whenItems = chosenPolicy
                    this.copyValue.aggregateRules[index].whenItems = chosenPolicy
                    // console.log("policies2")
                    // console.log(this.copyValue.aggregateRules[index].whenItems)
                }
                if(chosenPolicy.length == 1 && !this.copyValue.aggregateRules[index].whenValue){
                    this.copyValue.aggregateRules[index].whenValue = chosenPolicy[0]
                }
            },
            chooseThenEvent(index){
                var chosenEvent = []
                var me = this

                if(Object.values(me.canvasbase.value.relations).length > 0){
                    Object.values(me.canvasbase.value.relations).forEach(function(rel, idx){
                        if(rel != null && me.copyValue.aggregateRules[index].whenValue && me.copyValue.aggregateRules[index].whenValue.elementView){
                            if(rel.sourceElement._type == 'org.uengine.modeling.model.Policy' && rel.targetElement._type == 'org.uengine.modeling.model.Event'){
                                if(me.copyValue.aggregateRules[index].whenValue.elementView.id == rel.sourceElement.elementView.id){
                                    chosenEvent.push(rel.targetElement)
                                }
                            }
                        }
                    })
                }
                // console.log('chosenEvent', chosenEvent.length)
                if(chosenEvent.length == 0){
                    var attachedEventList = []
                    if(Object.values(me.canvasbase.attachedLists.eventLists).length > 0){
                        Object.values(me.canvasbase.attachedLists.eventLists).forEach(function(event, idx){
                            var outer = {
                                x: (event.elementView.x - event.elementView.width / 2) - 10,
                                y: (event.elementView.y - event.elementView.height / 2) - 10,
                                width: event.elementView.width + 20,
                                height: event.elementView.height + 20
                            }

                            var inner = {
                                x: me.copyValue.elementView.x - me.copyValue.elementView.width / 2,
                                y: me.copyValue.elementView.y - me.copyValue.elementView.height / 2,
                                width: me.copyValue.elementView.width,
                                height: me.copyValue.elementView.height
                            }

                            if (me.canvasbase._isAttached(outer, inner)) {
                                attachedEventList.push(event);
                            }
                        })

                        chosenEvent = attachedEventList
                    }
                }

                // this.aggregateRules[index].thenItems = chosenEvent
                this.copyValue.aggregateRules[index].thenItems = chosenEvent

                if(chosenEvent.length == 1 && !this.copyValue.aggregateRules[index].thenValue){
                    this.copyValue.aggregateRules[index].thenValue = chosenEvent[0]
                }
            },
            resetAttribute(rule, option){
                var me = this
                me.givenGridApi.stopEditing();
                me.thenGridApi.stopEditing();

                for(var i = 0; i < me.givenRowData.length; i++){
                    rule.attributes[i].givenAtt = []

                    rule.attributes[i].aggregateAtt = []

                    rule.attributes[i].thenAtt = []

                    Object.keys(me.givenRowData[i]).forEach(function(data){
                        if(data.includes(me.givenName)){
                            var givenAtt = {
                                attKey: me.givenName + '_' + data.replace(me.givenName, ''),
                                attValue: me.givenRowData[i][data]
                            }
                            rule.attributes[i].givenAtt.push(givenAtt)
                        }
                        if(data.includes(me.aggregateName)){
                            var aggregateAtt = {
                                attKey: me.aggregateName + '_' + data.replace(me.aggregateName, ''),
                                attValue: me.givenRowData[i][data]
                            }
                            rule.attributes[i].aggregateAtt.push(aggregateAtt)
                        }
                    })

                    Object.keys(me.thenRowData[i]).forEach(function(data){
                        if(data.includes(me.thenName)){
                            var thenAtt = {
                                attKey: me.thenName + '_' + data.replace(me.thenName, ''),
                                attValue: me.thenRowData[i][data]
                            }
                            rule.attributes[i].thenAtt.push(thenAtt)
                        }
                    })
                }

                if(option == 'add'){
                    var attribute = JSON.parse(JSON.stringify(me.ruleAttribute))
                    rule.attributes.push(attribute)
                } else if(option == 'delete'){
                    rule.attributes.splice(me.rowIndex, 1)
                } else if(option == 'save'){
                    me.isOpenRules = false
                    // rule.show = false
                    // me.value.aggregateRules = me.copyValue.aggregateRules
                    // console.log(me.value.aggregateRules)
                }

                if(option != 'save'){
                    me.openExampleDialog(rule)
                }
            },
            getComponent(componentName) {
                let component = null
                let parent = this.$parent
                while (parent && !component) {
                    if (parent.$options.name === componentName) {
                        component = parent
                    }
                    parent = parent.$parent
                }
                return component
            },
        }
    }
</script>